import { render, staticRenderFns } from "./RekamMedis.vue?vue&type=template&id=b0524eb0&scoped=true&"
import script from "./RekamMedis.vue?vue&type=script&lang=js&"
export * from "./RekamMedis.vue?vue&type=script&lang=js&"
import style0 from "./RekamMedis.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RekamMedis.vue?vue&type=style&index=1&id=b0524eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0524eb0",
  null
  
)

export default component.exports